import faker from 'faker';
import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    displayId: {
      name: 'รหัส',
      width: '10rem',
    },
    name: {
      name: 'ชื่อผลงาน',
      width: '1fr',
    },
    description: {
      name: 'คำอธิบาย',
      width: '1fr',
    },
    lastUpdatedBy: {
      name: 'ผู้แก้ไขข้อมูล',
      width: '10rem',
    },
    updatedAt: {
      key: 'updatedAt',
      name: 'แก้ไขล่าสุด',
      width: '9rem',
      class: 'text-right',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDate();
      },
    },
  },
  columns: ['_primaryControls', '_increment', 'name', 'description', 'updatedAt'],
  sortable: ['name', 'updatedAt'],
};
